import randomColor from 'randomcolor'

export function generateRandomColor(opts) {
  return randomColor(opts)
}

export function generateRandomColorForUser(userId) {
  return generateRandomColor({
    seed: userId,
    luminosity: 'dark',
  })
}

export function getFontColor(hex) {
  const [r, g, b] = hexToRgb(hex)

  if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
    return '#000000'
  }
  return '#FFFFFF'
}

export function hexToRgb(hex, alpha) {
  // Ensure hex is in 'FFFFFF' format
  hex = hex
    .replace('#', '')
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => r + r + g + g + b + b)

  return hex.match(/.{2}/g).map((x) => parseInt(x, 16))
}

export function isLightColor(hex) {
  const [r, g, b] = hexToRgb(hex)

  if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
    return true
  }
  return false
}
